export default function IconA2() {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.55505 29.2961H7.91005C7.66068 29.2961 7.45068 29.4711 7.40255 29.7161L6.75943 33.1374C6.69818 33.4568 6.94318 33.7499 7.26693 33.7499H22.9338C23.2707 33.7499 23.5201 33.4305 23.4326 33.1024L22.9338 31.2036"
                stroke="#707070"
                strokeWidth="1.125"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.59473 2.25V31.8075H10.8547C12.5216 31.8075 13.8516 30.4119 13.7685 28.745L12.6179 5.12875C12.5391 3.51875 11.2091 2.25 9.59473 2.25Z"
                stroke="#707070"
                strokeWidth="1.125"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.0934 30.7487C16.424 30.1844 16.3409 29.6944 16.3847 28.745L17.5353 5.12875C17.6184 3.51875 18.9484 2.25 20.5584 2.25V24.405"
                stroke="#707070"
                strokeWidth="1.125"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M12.7354 7.57007H17.4079" stroke="#707070" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.31 29.2961H13.7725" stroke="#707070" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M19.5607 26.1549C19.6482 25.8793 19.9063 25.6912 20.1951 25.6912H23.7651H27.6588C27.9607 25.6912 28.2232 25.8924 28.302 26.1812L29.5838 30.9062C29.8332 31.8205 29.1507 32.7218 28.2013 32.7349C27.6282 32.7437 27.1032 32.4068 26.8626 31.8818L26.0795 30.1537H21.4026L20.6807 31.8818C20.462 32.4068 19.9501 32.748 19.3813 32.748C18.4276 32.748 17.7495 31.8205 18.0426 30.9149L19.5607 26.1549Z"
                stroke="#707070"
                strokeWidth="1.125"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.1234 21.3206C26.1234 21.3206 26.9546 22.7206 25.8959 23.1581C24.8371 23.5956 23.8965 21.0274 23.8965 22.7512V25.6912"
                stroke="#707070"
                strokeWidth="1.125"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.075 28.7713C26.4616 28.7713 26.775 28.4579 26.775 28.0713C26.775 27.6847 26.4616 27.3713 26.075 27.3713C25.6884 27.3713 25.375 27.6847 25.375 28.0713C25.375 28.4579 25.6884 28.7713 26.075 28.7713Z"
                fill="#707070"
            />
            <path
                d="M22.2859 28.7713C22.6725 28.7713 22.9859 28.4579 22.9859 28.0713C22.9859 27.6847 22.6725 27.3713 22.2859 27.3713C21.8993 27.3713 21.5859 27.6847 21.5859 28.0713C21.5859 28.4579 21.8993 28.7713 22.2859 28.7713Z"
                fill="#707070"
            />
        </svg>
    );
}
